<template>
  <div id="standardFormat">
    <template v-if="$route.name === 'standardFormat'">
        <div id="topAnchor"></div>
        <ots-main-title></ots-main-title>
        <el-form>
            <div class="mainCon" style="margin:0px;padding:24px 0px 0px 25px;">
                <div style="display:flex; flex-wrap: wrap;" class="standardFormat">
                    <el-form-item style="margin-right: 25px;">
                        <div>课程名称：<font class="titleCourse">{{ courseName }}</font></div>
                    </el-form-item>
                    <el-form-item label="选择入库题型：" style="margin-right: 16px;">
                        <el-select v-model="baseInfo.questionTypeId" placeholder="请选择" filterable @change="getAllCount">
                            <el-option v-for="item in baseInfo.questionTypeIdList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" plain round @click="searchForm" style="margin-top: -3px;" :loading="loadedFlag" :disabled="manyCount.allQuestionCount<=0"> 查询 </el-button>
                        <font style="margin-left: 20px;" v-if="showAllCountFlag">待入库试题数量：<font class="tipRed">{{ manyCount.allQuestionCount }}</font></font>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="mainCon" style="margin-top: 16px;" v-if="showDownContent">
            <div class="topDivLeft">
              <div class="topDivLeftTitle">
                转换后的试题编辑
                <el-link type="primary" style="margin-left: 20px;" @click="dialogContent.batchDialog=true;">批量编辑</el-link>
              </div>
              <div>
                <el-card shadow="hover" style="margin-top: 10px;" v-for="(item,index) in tableData" :key="index">
                  <ul v-if="item.haveSubQuestion">
                      <li :id="'questionIndex' + index">当前页第<span class="titleBlue"> {{index + 1}} </span>题</li>
                      <li>
                        【试题题型】
                        <el-select v-model="item.questionTypeId" placeholder="请选择">
                          <el-option
                            v-for="item in baseInfo.typeIdList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li>
                        <div>【试题题干】
                          <el-tooltip effect="dark" content="点击修改【试题题干】" placement="top-start">
                            <!-- <i class="editPenIcon" @click="showLayer(item,2)"></i> -->
                            <i class="el-icon-edit icon-pointer" @click="showLayer(item,2)"></i>
                          </el-tooltip>
                        </div>
                        <div class="complexLeftContent" v-html="item.title"></div>
                      </li>
                      <li>【课程结构】
                          <el-cascader
                            v-model="item.categoryItemCode"
                            :options="baseInfo.categoryList"
                            :props="{ expandTrigger: 'hover',checkStrictly: true }">
                          </el-cascader>
                      </li>
                      <li>【试题难度】
                        <el-select v-model="item.difficulty" placeholder="请选择">
                          <el-option
                            v-for="item in baseInfo.diffcultList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li v-if="item.haveSubQuestion">
                        <el-card shadow="hover" style="margin-top: 10px;" v-for="(subItem,subIndex) in item.subQuestions" :key="subIndex+999">
                            <ul>
                                <li>子题第<span class="titleGreen"> {{ subIndex+1 }} </span>题</li>
                                <li>
                                  【试题题型】
                                  <el-select v-model="subItem.questionTypeId" placeholder="请选择">
                                    <el-option
                                      v-for="item in baseInfo.typeIdList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                    </el-option>
                                  </el-select>
                                </li>
                                <li>
                                    <div>【子题题干】
                                      <el-tooltip effect="dark" content="点击修改【子题题干】" placement="top-start">
                                        <i class="el-icon-edit icon-pointer" @click="showItemLayer(item,subIndex,2)"></i>
                                      </el-tooltip>
                                    </div>
                                    <div class="leftContent" v-html="subItem.title"></div>
                                </li>
                                <li v-if="subItem.options != null && subItem.options.length > 0">
                                    <div>【子题选项】
                                      <el-tooltip effect="dark" content="点击修改【子题选项】" placement="top-start">
                                        <i class="el-icon-edit icon-pointer" @click="showItemLayer(item,subIndex,3)"></i>
                                      </el-tooltip>
                                    </div>
                                    <div class="leftContent" v-html="formatOptions(subItem)"></div>
                                </li>
                                <li>
                                    <div>【子题答案】
                                      <el-tooltip effect="dark" content="点击修改【子题答案】" placement="top-start">
                                        <i class="el-icon-edit icon-pointer" @click="showItemLayer(item,subIndex,4)"></i>
                                      </el-tooltip>
                                    </div>
                                    <div class="leftContent" v-html="formatAnswer(subItem)"></div>
                                </li>
                                <li>
                                    <div>【子题解析】
                                      <el-tooltip effect="dark" content="点击修改【子题解析】" placement="top-start">
                                        <i class="el-icon-edit icon-pointer" @click="showItemLayer(item,subIndex,5)"></i>
                                      </el-tooltip>
                                    </div>
                                    <div class="leftContent" v-html="subItem.analysis"></div>
                                </li>
                                <li>【子题分数】
                                    <el-input v-model="subItem.score" placeholder="请输入试题分数" @input="validateNumberInput($event, subItem)"></el-input> 分
                                </li>
                            </ul>
                        </el-card>
                      </li>
                      <li class="sub-button">
                          <el-button type="primary" plain round @click="submitComplex(item)">确定保存</el-button>
                          <span class="RemindSaveCss" v-if="item.submitCount>0">已保存</span>
                      </li>
                  </ul>
                  <ul v-else>
                      <li :id="'questionIndex' + index">当前页第<span class="titleBlue"> {{index + 1}} </span>题</li>
                      <li>
                        【试题题型】
                        <el-select v-model="item.questionTypeId" placeholder="请选择">
                          <el-option
                            v-for="item in baseInfo.typeIdList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li>
                        <div>【试题题干】
                          <el-tooltip effect="dark" content="点击修改【试题题干】" placement="top-start">
                             <i class="el-icon-edit icon-pointer" @click="showLayer(item,2)"></i>
                          </el-tooltip>
                        </div>
                        <div class="leftContent" v-html="item.title"></div>
                      </li>
                      <li v-if="item.options != null && item.options.length > 0">
                        <div>【试题选项】
                          <el-tooltip effect="dark" content="点击修改【试题选项】" placement="top-start">
                             <i class="el-icon-edit icon-pointer" @click="showLayer(item,3)"></i>
                          </el-tooltip>
                        </div>
                        <div class="leftContent" v-html="formatOptions(item)"></div>
                      </li>
                      <li>
                        <div>【试题答案】
                          <el-tooltip effect="dark" content="点击修改【试题答案】" placement="top-start">
                            <i class="el-icon-edit icon-pointer" @click="showLayer(item,4)"></i>
                          </el-tooltip>
                        </div>
                        <div class="leftContent" v-html="formatAnswer(item)"></div>
                      </li>
                      <li>
                        <div>【试题解析】
                          <el-tooltip effect="dark" content="点击修改【试题解析】" placement="top-start">
                            <i class="el-icon-edit icon-pointer" @click="showLayer(item,5)"></i>
                          </el-tooltip>
                        </div>
                        <div class="leftContent" v-html="item.analysis"></div>
                      </li>
                      <li>【课程结构】
                          <el-cascader
                            v-model="item.categoryItemCode"
                            :options="baseInfo.categoryList"
                            :props="{ expandTrigger: 'hover',checkStrictly: true }">
                          </el-cascader>
                      </li>
                      <li>【试题难度】
                        <el-select v-model="item.difficulty" placeholder="请选择">
                          <el-option
                            v-for="item in baseInfo.diffcultList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </li>
                      <li>【试题分数】
                        <el-input v-model="item.score" placeholder="请输入试题分数" @input="validateNumberInput($event, item)"></el-input> 分
                      </li>
                      <li class="sub-button">
                        <el-button type="primary" plain round @click="submitSignle(item)">确定保存</el-button>
                        <span class="RemindSaveCss" v-if="item.submitCount>0">已保存</span>
                      </li>
                  </ul>
                </el-card>
              </div>
            </div>
            <div class="topDivRight">
                <el-card>
                  <ul>
                    <li class="li-Title">入库统计</li>
                    <li>本次可入库试题</li>
                    <li class="li-green">{{ manyCount.rightQuestionCount }}</li>
                    <li>题型：</li>
                    <li class="li-paddingLeft" v-for="(value,key) in baseInfo.typeCountList">{{ key }}：{{ value }}</li>
                    <li>有问题需修改试题</li>
                    <li class="li-red">{{ manyCount.modifyQuestionCount }}</li>
                    <li class="li-button"><el-button type="primary" plain round @click="goModify">去修改</el-button></li>
                    <li class="li-button"><el-button type="primary" round @click="submitToOts" :disabled="manyCount.rightQuestionCount<=0">题目入库</el-button></li>
                  </ul>
                </el-card>
            </div>
            <div class="floating-box">
              <div>
                <el-button type="primary" plain @click="goUpPage" :disabled="beforePageJudge">上一页</el-button>
                <el-button type="primary" plain @click="goNextPage" :disabled="nextPageJudge">下一页</el-button>
                <el-button type="primary" plain @click="jumpPageFn" :disabled="jumpPageJudge">跳转到</el-button> <el-input v-model="manyCount.jumpPage" placeholder="页码" :disabled="jumpPageNoJudge"></el-input> 页
              </div>
              <div style="margin-top: 20px;">每页{{ manyCount.pageSize }}题 / 共{{ manyCount.allQuestionCount }}题 / 当前第{{ manyCount.currentPage }}页 / 共{{ manyCount.totalPage}}页</div>
            </div>
        </div>
        <div class="mainCon" style="margin-top: 16px;" v-else>
          <div class="waiteDiv">试题待编辑区</div>
        </div>
        <ots-custom-dialog :dialog.sync="dialogContent.batchDialog" title="批量编辑试题" width="40%">
          <template v-slot:content>
            <div>
              <el-form :model="dialogContent">
                <el-form-item label="1.批量设置题型" class="mb20">
                  <el-select v-model="dialogContent.typeId" clearable placeholder="请选择" filterable>
                    <el-option v-for="item in baseInfo.typeIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="2.批量添加课程结构" class="mb20">
                  <el-cascader
                    v-model="dialogContent.categoryId"
                    :options="baseInfo.categoryList"
                    :props="{ expandTrigger: 'hover',checkStrictly: true }">
                  </el-cascader>
                </el-form-item>
                <el-form-item label="3.批量设置难度" class="mb20">
                  <el-select v-model="dialogContent.difficultId" clearable placeholder="请选择" filterable>
                    <el-option v-for="item in baseInfo.diffcultList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="4.批量设置分数" class="mb20">
                  <el-input v-model="dialogContent.score" placeholder="请输入试题分数" @input="validateNumberInput($event, dialogContent)"></el-input> 分
                </el-form-item>
              </el-form>
            </div>
            <div><font class="tipRed">备注：</font>批量设置将影响当前查询结果中全部的 <span class="tipRed">{{ manyCount.allQuestionCount }}</span> 道题。</div>
          </template>
          <template v-slot:footer>
            <el-button round @click="dialogContent.batchDialog = false">取消</el-button>
            <el-button round type="primary" @click="submitBatch">批量设置</el-button>
          </template>
        </ots-custom-dialog>

        <el-dialog :modal="false" :visible.sync="layerContent.layerDialog" :title="layerContent.title" width="50%">
          <template slot:content>
            <div class="contentCss">
              <div v-if="layerContent.currentStepId==2"><!--题干-->
                <ots-editor v-model="layerContent.tmpTitle" />
              </div>

              <div v-else-if="layerContent.currentStepId==3"><!--选项-->
                <div v-if="layerContent.tmpOptionsType == 1">
                  <div class="topTip">
                    <i class="el-icon-s-opportunity"></i> 可在下方修改各选项内容：
                  </div>
                  <div v-for="(item,index) in layerContent.tmpOptionsSelect" :key="index" class="optionSelectFatherCss">
                    {{String.fromCharCode(65 + index)}}：<el-input v-model="layerContent.tmpOptionsSelect[index]" class="optionSelectCss"></el-input>
                  </div>
                </div>
                <div v-else></div>
              </div>

              <div v-else-if="layerContent.currentStepId==4"><!--答案-->
                <div v-if="layerContent.tmpOptionsType == 1 && layerContent.tmpAnswerType == 1"><!--单选/多选-->
                  <div class="topTip">
                    <i class="el-icon-s-opportunity"></i> 请在下方勾选正确答案：
                  </div>
                  <div v-for="(item,index) in layerContent.tmpOptionsSelect" :key="index" class="optionSelectFatherCss">
                    <el-checkbox v-model="layerContent.tmpAnswerSelect[index]" :label="`${String.fromCharCode(65 + index)}: ${layerContent.tmpOptionsSelect[index]}`" border size="medium" class="answerSelectCss"></el-checkbox>
                  </div>
                </div>
                <div v-else-if="layerContent.tmpOptionsType == 2 && layerContent.tmpAnswerType == 2"><!--判断-->
                  <div v-if="layerContent.judgeFlag" class="answerJudgeFatherCss"><!--如果真的是判断-->
                    <div class="judgeDiv">
                      <i class="el-icon-s-opportunity"></i> 请在下方勾选正确答案：
                    </div>
                    <el-radio v-model="layerContent.tmpAnswerString" label="正确" border>正确</el-radio>
                    <el-radio v-model="layerContent.tmpAnswerString" label="错误" border>错误</el-radio>
                    <div class="judgeTip">
                      <i class="el-icon-warning"></i> 如果该题不是判断题，请点击<el-link type="primary" @click="changeJudgeFlag">此处</el-link>切换成修改试题答案模式
                    </div>
                  </div>
                  <div v-else><!--如果用户觉得这个不是判断题-->
                    <ots-editor v-model="layerContent.tmpAnswerString" />
                  </div>
                </div>
                <div v-else><!--除了 单选/多选/判断 以外的所有类型的答案-->
                  <ots-editor v-model="layerContent.tmpAnswerString" />
                </div>
              </div>

              <div v-else-if="layerContent.currentStepId==5"><!--解析-->
                <ots-editor v-model="layerContent.tmpAnalysis" />
              </div>
            </div>
          </template>
          <template slot:footer>
            <div class="footerCss">
              <el-button round @click="layerContent.layerDialog = false">取消</el-button>
              <el-button round type="primary" @click="layerSubmit">确定</el-button>
            </div>
          </template>
        </el-dialog>

    </template>
    <template v-else>
        <router-view></router-view>
    </template>
    <div class="maskDiv" v-if="layerContent.layerDialog"></div>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  getQuestionTypeApi,
  getCategoryTreeFn,
  getQuestionTypeByTaskIdAndCourseIdFn,
  getQuestionForWaitQueueFn,
  getQuestionForWaitNumberFn,
  getQuestionForCountTotalFn,
  getQuestionForCountDetailFn,
  saveQuestionForOtsFn,
  saveQuestionSingleFn,
  saveQuestionBatchFn,
  saveQuestionFieldFn,
  saveQuestionField4SubFn
 } from "@/http/modules/dataV";

export default {
  name: "standardFormat",
  components: { VueUeditorWrap },
  data () {
    return {
      taskId:this.$route.query.taskId,
      courseName: this.$route.query.courseName,
      loadedFlag: true,
      showAllCountFlag: false,
      showDownContent: false,
      tableData: [],
      selectForm: {
        courseId : this.$route.query.courseId,
        questionTypeId : ''
      },
      originalCategoryList:[],
      baseInfo:{
        questionTypeId: "",
        questionTypeIdList:[], // 查询条件里面的题型列表
        typeIdList:[], // 试题实际要选择的题型列表
        diffcultList:[], // 难度列表
        categoryList:[],
        typeCountList:[],
      },
      manyCount :{
        allQuestionCount: 0,
        rightQuestionCount : 0,
        modifyQuestionCount : 0,
        pageSize : 10,
        currentPage : 1,
        totalPage : 1,
        jumpPage : '',
      },
      dialogContent:{
        batchDialog: false,
        typeId: '',
        categoryId: '',
        difficultId: '',
        score: '',
      },
      layerContent:{
        layerDialog: false, //是否开启弹窗
        currentItem: null,  //当前对象
        currentStepId: '',  //当前处理的是什么数据 2-题干 3-选项 4-答案 5-解析
        subIndex: -1,       //如果大于-1，则当前处理的是子题的数据，这个对应的是item.subQuestions的索引
        title: '',
        tmpTitle: '',
        tmpOptionsType: 0,  // 1:单选或多选 ； 2:其他
        tmpOptionsSelect: [],
        tmpOptionsString: '',
        tmpAnswerType: 0,   // 1:单选或多选 ； 2:其他
        tmpAnswerSelect: [],
        tmpAnswerString: '',
        judgeFlag: false,   // 是否是判断题
        tmpAnalysis: '',
      },
      currentTitle:['','','试题题干','试题选项','试题答案','试题解析'],
      currentSubItemTitle:['','','子题题干','子题选项','子题答案','子题解析'],
    }
  },
  mounted () {
    this.initData();
    //this.handleScroll();
  },
  computed: {
      beforePageJudge() {
          return this.manyCount.totalPage && this.manyCount.currentPage <= 1 ? true : false;
      },
      nextPageJudge() {
          return this.manyCount.totalPage && this.manyCount.totalPage <= this.manyCount.currentPage ? true : false;
      },
      jumpPageJudge() {
          return this.manyCount.totalPage ? this.manyCount.totalPage>1 ? false : true : true;
      },
      jumpPageNoJudge() {
          return this.manyCount.totalPage ? false : true;
      }
  },
  methods: {
    handleScroll() {
      document.documentElement.style.setProperty('overflow-y', 'auto', 'important');
      document.documentElement.style.setProperty('height', 'auto', 'important');
    },
    async initData() {
      // 获取查询条件里面的试题题型
      let params = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
      }
      const { data: questionTypeMap } = await getQuestionTypeByTaskIdAndCourseIdFn(params);
      if(questionTypeMap){
        this.baseInfo.questionTypeIdList = Object.entries(questionTypeMap).map(([id, name]) => ({ id, name }));
        this.baseInfo.questionTypeId = this.baseInfo.questionTypeIdList[0].name;
      }
      // 获取上面查询条件里面试题题型对应的题目数量
      this.getAllCount();

      // 获取试题实际使用的题型
      const { data: typeMap } = await getQuestionTypeApi();
      this.baseInfo.typeIdList = Object.entries(typeMap).map(([id, name]) => ({ id, name }));

      // 获取试题难度
      this.baseInfo.diffcultList = [{id:1,name:"容易"},{id:2,name:"较易"},{id:3,name:"中等"},{id:4,name:"较难"},{id:5,name:"困难"}]

      // 获取课程结构
      const { code:categoryTreeCode,data: categoryTree } = await getCategoryTreeFn({courseId : this.selectForm.courseId});
      this.originalCategoryList = categoryTreeCode == 1 ? categoryTree : [];
      this.baseInfo.categoryList = categoryTreeCode == 1 ? this.formatToCascader(categoryTree) : [];

      this.loadedFlag = false;
    },
    async getAllCount () {
      const params = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
        questionTypeName:this.baseInfo.questionTypeId
      };
      const { code,data } = await getQuestionForCountTotalFn(params);
      this.manyCount.allQuestionCount = code == 1 ? data.total : 0;
      this.showAllCountFlag = true;
    },
    async goModify () {
      const params = {
        taskId: this.taskId,
        courseId:this.selectForm.courseId,
        questionTypeName:this.baseInfo.questionTypeId
      };
      const { code,data } = await getQuestionForWaitNumberFn(params);
      if(code == 1 && data >= 0){
        const pageNo = Math.ceil(data/this.manyCount.pageSize);
        const position = (data - 1) % this.manyCount.pageSize;
        if(pageNo === this.manyCount.currentPage){
          this.anchorFn('questionIndex' + position);
        }else{
          this.manyCount.currentPage = pageNo;
          this.searchForm(position);
        }
      }
    },
    async getRightData() {
      //获取右侧数据（就拿2个数）
      let params = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
        questionTypeName:this.baseInfo.questionTypeId
      }
      const { code:questionCountCode,data: questionCount } = await getQuestionForCountDetailFn(params);
      this.manyCount.rightQuestionCount = questionCountCode == 1 ? questionCount.countUsable : 0;
      this.manyCount.modifyQuestionCount = questionCountCode == 1 ? questionCount.countDisable : 0;
      this.baseInfo.typeCountList = questionCountCode == 1 ? questionCount.typeCount : [];
    },
    async searchForm(position) {
      //获取右侧数据
      this.getRightData();

      //获取左侧数据
      let params = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
        questionTypeName:this.baseInfo.questionTypeId,
        page:this.manyCount.currentPage,
        size:this.manyCount.pageSize,
      }
      const { code:questionDataCode,data: questionData } = await getQuestionForWaitQueueFn(params);
      if(questionDataCode == 1 && questionData.records){
        questionData.records.forEach(item => {
          item.questionTypeId = item.questionTypeId == null ? '' : item.questionTypeId;
          item.categoryItemCode = item.categoryItemCode == null ? [] : this.getPathByCode(item.categoryItemCode);
          item.difficulty = item.difficulty == null ? '' : item.difficulty;
          item.score = item.score == null ? '' : item.score;
          item.submitCount = 0;
          if(item.haveSubQuestion){
            if(item.subQuestions && item.subQuestions.length > 0){
              item.subQuestions.forEach(subItem => {
                subItem.questionTypeId = subItem.questionTypeId == null ? '' : subItem.questionTypeId;
                subItem.score = subItem.score == null ? '' : subItem.score;
              })
            }
          }
        });
        this.tableData = questionData.records;
      }

      //赋值各种分页数据
      this.showDownContent = true;
      this.manyCount.pageSize = questionData.size;
      this.manyCount.currentPage = questionData.current;
      this.manyCount.totalPage = questionData.pages;

      if(position != null){
        this.anchorFn('questionIndex' + position);
      }else{
        this.anchorFn('topAnchor');
      }
    },
    anchorFn(target){
      const topElement = document.getElementById(target);
      if (topElement) {
        topElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    getPathByCode(code) {
      if (code == null || code == '' || !this.originalCategoryList.some(item => item.code === code)) {
        return []; // 如果code不存在，返回空数组
      }
      const path = [];
      let currentCode = code;

      const nodeMap = {};
      this.originalCategoryList.forEach(item => {
        nodeMap[item.code] = item;
      });

      // 从当前节点向上追溯直到根节点
      while (currentCode && nodeMap[currentCode]) {
        const node = nodeMap[currentCode];
        path.unshift(node.code); // 添加到数组开头
        currentCode = node.parentCode;
      }
      return path;
    },
    async goUpPage(){
      this.manyCount.currentPage--;
      this.searchForm();
    },
    async goNextPage(){
      this.manyCount.currentPage++;
      this.searchForm();
    },
    async jumpPageFn(){
      if(!this.manyCount.jumpPage){
        this.$message.warning("请输入正确的页码");
        return;
      }
      if(this.manyCount.jumpPage <= 0){
        this.manyCount.jumpPage = 1;
      }
      if(this.manyCount.jumpPage > this.manyCount.totalPage){
        this.manyCount.jumpPage = this.manyCount.totalPage;
      }
      this.manyCount.currentPage = this.manyCount.jumpPage;
      this.searchForm();
    },
    async submitSignle(item){
      if(item.questionTypeId==''){
        this.$message.warning("请选择试题题型");
        return;
      }
      if(item.categoryItemCode==''){
        this.$message.warning("请选择课程结构");
        return;
      }
      if(item.difficulty==''){
        this.$message.warning("请选择试题难度");
        return;
      }
      if(item.score==''){
        this.$message.warning("请录入试题分数");
        return;
      }

      //这里因为是级联菜单的数组的形式['00081007', '00081007002', '00081007002002']，所以需要获取最后一项的值
      let tmpCategoryItemCode = item.categoryItemCode[item.categoryItemCode.length-1]

      let params = {
        questionId : item.id,
        title : item.title,
        answer : item.answer,
        analysis : item.analysis,
        questionTypeId : item.questionTypeId,
        difficulty : item.difficulty,
        categoryItemCode : tmpCategoryItemCode,
        score : item.score
      }
      if(item.options != null && item.options.length > 0){
        params = {
          ...params,
          options : item.options,
        }
      }
      const { code,msg } = await saveQuestionFieldFn(params);
      if(code == 1){
        this.$message.success(msg);
        item.submitCount++;
        this.getRightData();
      }
    },
    async submitComplex(item){
      if(item.questionTypeId==''){
        this.$message.warning("请选择试题题型");
        return;
      }
      if(item.categoryItemCode==''){
        this.$message.warning("请选择课程结构");
        return;
      }
      if(item.difficulty==''){
        this.$message.warning("请选择试题难度");
        return;
      }
      if(item.haveSubQuestion){
        if(item.subQuestions && item.subQuestions.length > 0){
          let typeString = '';
          let scoreString = '';
          item.subQuestions.forEach((subItem, subIndex) => {
            if(subItem.questionTypeId==''){
              typeString += `${subIndex+1}、`;
            }
            if(subItem.score==''){
              scoreString += `${subIndex+1}、`;
            }
          })
          if(typeString != ''){
            typeString = typeString.substring(0, typeString.length - 1);
            this.$message.warning(`子题${typeString}请选择试题题型`);
            return;
          }
          if(scoreString != ''){
            scoreString = scoreString.substring(0, scoreString.length - 1);
            this.$message.warning(`子题${scoreString}请录入试题分数`);
            return;
          }
        }
      }
      //dataInfo:一级题目的内容，示例：id#typeid#diffcult#category#score
      //subDataList:二级题目的内容，示例：id#typeid#score,id#typeid#score,id#typeid#score

      //这里因为是级联菜单的数组的形式['00081007', '00081007002', '00081007002002']，所以需要获取最后一项的值
      let tmpCategoryItemCode = item.categoryItemCode[item.categoryItemCode.length-1]

      //特殊的点：复合题的总分是所有子题分数的合计，需要计算一下
      let tmpScore = 0;
      let tmpSubInfo = [];
      let haveSubFlag = false;
      if(item.haveSubQuestion){
        if(item.subQuestions && item.subQuestions.length > 0){
          haveSubFlag = true;
          item.subQuestions.forEach(subItem => {

            tmpScore += Number(subItem.score);

            const tmpInfo = {
              subQuestionId: subItem.id,
              title: subItem.title,
              answer: subItem.answer,
              analysis: subItem.analysis,
              questionTypeId: subItem.questionTypeId,
              score: subItem.score
            };

            const subInfo = subItem.options?.length > 0 ? { ...tmpInfo, options: subItem.options } : tmpInfo;

            tmpSubInfo.push(subInfo);
          })
        }
      }
      let params = {
        questionId : item.id,
        title : item.title,
        questionTypeId : item.questionTypeId,
        difficulty : item.difficulty,
        categoryItemCode : tmpCategoryItemCode,
        score : tmpScore,
      }
      // console.log(params);
      // console.log(tmpSubInfo);
      // console.log(JSON.stringify(tmpSubInfo));

      let subSubmitFlag = [];
      if(haveSubFlag){
        for(let i = 0;i < tmpSubInfo.length ; i++){
          let {code: subCode} = await saveQuestionField4SubFn(tmpSubInfo[i]);
          if(subCode != 1){
            subSubmitFlag.push(i+1);
          }
        }
      }
      const { code,msg } = await saveQuestionFieldFn(params);
      if(code == 1){
        this.$message.success(msg);
        item.submitCount++;
      }
      if(subSubmitFlag.length > 0){
        this.$message.warning(`子题[${subSubmitFlag.join('、')}]提交失败`);
      }
      this.getRightData();
    },
    async submitBatch(){
      let i = 0;
      if(this.dialogContent.typeId == ''){
        i++;
      }
      if(this.dialogContent.categoryId == ''){
        i++;
      }
      if(this.dialogContent.difficultId == ''){
        i++;
      }
      if(this.dialogContent.score == ''){
        i++;
      }
      if(i >= 4){
        this.$message.warning("至少要选择或填写一项数据");
        return;
      }
      let tmpCategoryCode = this.dialogContent.categoryId[this.dialogContent.categoryId.length-1]
      let params = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
        questionTypeName:this.baseInfo.questionTypeId,
        typeId:this.dialogContent.typeId,
        categoryCode:tmpCategoryCode,
        difficultId:this.dialogContent.difficultId,
        score:this.dialogContent.score,
      }
      this.dialogContent.batchDialog = false;
      const { code } = await saveQuestionBatchFn(params);
      if(code == 1){
        this.dialogContent.typeId = '';
        this.dialogContent.categoryId = '';
        this.dialogContent.difficultId = '';
        this.dialogContent.score = '';
        this.$message.success("提交成功");
        this.searchForm();
      }

    },
    formatToCascader(data) {
      const map = new Map();
      const result = [];

      // 第一遍遍历：创建所有节点的映射
      data.forEach(item => {
        map.set(item.code, {
          value: item.code,
          label: item.name,
          children: []
        });
      });

      // 第二遍遍历：构建层级关系
      data.forEach(item => {
        const currentNode = map.get(item.code);

        // 如果有父节点，将当前节点添加到父节点的children中
        if (item.parentCode && map.has(item.parentCode)) {
          const parentNode = map.get(item.parentCode);
          parentNode.children.push(currentNode);

          // 按sequence排序
          parentNode.children.sort((a, b) => item.sequence - item.sequence);
        } else {
          // 没有父节点，说明是根节点
          result.push(currentNode);
        }
      });

      // 对根节点按sequence排序
      result.sort((a, b) => a.sequence - b.sequence);

      // 移除没有children的空数组
      const removeEmptyChildren = (nodes) => {
        nodes.forEach(node => {
          if (node.children && node.children.length === 0) {
            delete node.children;
          } else if (node.children && node.children.length > 0) {
            removeEmptyChildren(node.children);
          }
        });
      };
      removeEmptyChildren(result);
      return result;
    },
    async submitToOts(){
      //把数据推送给OTS
      let params = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
        questionTypeName: this.baseInfo.questionTypeId,
      }
      const { code,data } = await saveQuestionForOtsFn(params);
      //查询“入库题型”下拉列表中是否还有数据
      let tmpParams = {
        taskId: this.taskId,
        courseId: this.selectForm.courseId,
      }
      const { data: questionTypeMap } = await getQuestionTypeByTaskIdAndCourseIdFn(tmpParams);
      //如果推送给OTS成功
      if(code == 1){
        this.$message.success(data);
        if(questionTypeMap == null || (questionTypeMap && questionTypeMap.length == 0)){//如果“入库题型”下拉列表中【没有数据】了，则跳转到前面的任务页面
          setTimeout(() => {
            this.$router.push({
              name: "standardTask",
            });
          }, 1000)
        }else{//如果“入库题型”下拉列表中还有数据，则需要判断当前查询的这个入库题型是否还有未入库的试题
          const countParams = {
            taskId: this.taskId,
            courseId: this.selectForm.courseId,
            questionTypeName:this.baseInfo.questionTypeId
          };
          const { code: countCode,data: countData } = await getQuestionForCountTotalFn(countParams);
          this.manyCount.allQuestionCount = countCode == 1 ? countData.total : 0;
          if(this.manyCount.allQuestionCount == 0){ //如果当前下拉列表的入库题型下面已经没有需要入库的试题了
            this.baseInfo.questionTypeIdList = this.baseInfo.questionTypeIdList.filter(item => item.name != this.baseInfo.questionTypeId);//那么就从下拉列表中移除当前这个题型
            this.baseInfo.questionTypeId = this.baseInfo.questionTypeIdList[0].name;//并且把第一个数据默认成当前题型
            this.manyCount.currentPage = 1;//改页码
            this.manyCount.pageSize = 10;//改每页显示条数
            this.searchForm();//然后重新查询数据渲染页面（这里面已经包含了右侧数据刷新的接口this.getRightData();）
          }else{//如果当前下拉列表的入库题型下面还有需要入库的试题
            this.getRightData();//刷新右侧数据
          }
          this.getAllCount();//再整体刷新一下查询按钮后面对应的待入库试题数量
        }
      }
    },
    validateNumberInput(value, item) {
      let filtered = value.replace(/[^\d.]/g, '');
      if (filtered.startsWith('.')) {
        filtered = filtered.substring(1);
      }
      const dotCount = (filtered.match(/\./g) || []).length;
      if (dotCount > 1) {
        filtered = filtered.replace(/\./g, '', dotCount - 1);
      }
      const parts = filtered.split('.');
      parts[0] = parts[0].slice(0, 3);
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
      }
      this.$set(item, 'score', parts.join('.'));
    },
    formatOptions(item){
      if(!item.options) return '';
      if(this.judgeIsArray(item.options) && this.judgeIsArray(item.answer)){
        //单选或者多选
        const tmpOptionMap = JSON.parse(item.options);
        let tmp = tmpOptionMap.map((option, index) => {
          return `<div>${String.fromCharCode(65 + index)}：${option}</div>`;
        });
        return tmp.join('');
      }else{
        return item.options;
      }
    },
    formatAnswer(item){
      if(!item.answer) return '';
      if(this.judgeIsArray(item.options) && this.judgeIsArray(item.answer)){
        //单选或者多选
        const tmpAnswerMap = JSON.parse(item.answer);
        let tmp = tmpAnswerMap.map((option) => {
          return `${String.fromCharCode(64 + option)}`;
        });
        return tmp.join('，');
      }else{
        return item.answer;
      }
    },
    formatDialogOptions(item){
      this.layerContent.tmpOptionsType = 2;
      this.layerContent.tmpOptionsSelect = [];
      this.layerContent.tmpOptionsString = '';
      if(!item.options) return '当前没有可编辑的试题选项！';
      if(this.judgeIsArray(item.options) && this.judgeIsArray(item.answer)){
        //单选或者多选
        const tmpOptionMap = JSON.parse(item.options);
        this.layerContent.tmpOptionsType = 1;
        this.layerContent.tmpOptionsSelect = tmpOptionMap;
      }else{
        this.layerContent.tmpOptionsType = 2;
        this.layerContent.tmpOptionsString = item.options;
      }
    },
    formatDialogAnswer(item){
      this.layerContent.tmpAnswerType = 3;
      this.layerContent.tmpAnswerSelect = [];
      this.layerContent.tmpAnswerString = '';
      this.layerContent.judgeFlag = false;
      if(!item.answer) return '';
      if(this.judgeIsArray(item.options) && this.judgeIsArray(item.answer)){
        //单选或者多选
        const tmpAnswer = JSON.parse(item.answer);
        this.layerContent.tmpAnswerType = 1;
        let tmpAnswerMap = [];
        this.layerContent.tmpOptionsSelect.map((option, index) => {
          if(tmpAnswer.includes(index+1)){
            tmpAnswerMap.push(true);
          }else{
            tmpAnswerMap.push(false);
          }
        })
        this.layerContent.tmpAnswerSelect = tmpAnswerMap;
      }else{
        if(item.answer.replace(/<[^>]*>/g, '') == '正确' || item.answer.replace(/<[^>]*>/g, '') == '错误'){
          this.layerContent.tmpAnswerType = 2;
          this.layerContent.judgeFlag = true;
          this.layerContent.tmpAnswerString = item.answer.replace(/<[^>]*>/g, '');
        }else{
          this.layerContent.tmpAnswerType = 3;
          this.layerContent.tmpAnswerString = item.answer;
        }
      }
    },
    judgeIsArray(value) {
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            return true;
          }else{
            return false;
          }
        } catch (error) {
          return false;
        }
      } else {
        return false;
      }
    },
    showLayer(item,stepId){
      this.layerContent.currentItem = item;
      this.layerContent.currentStepId = stepId;
      this.layerContent.subIndex = -1;
      this.layerContent.title = this.currentTitle[stepId];
      if(stepId==2){
        this.layerContent.tmpTitle = item.title;
      }
      if(stepId==3){
        this.formatDialogOptions(item);
      }
      if(stepId==4){
        this.formatDialogOptions(item);
        this.formatDialogAnswer(item);
      }
      if(stepId==5){
        this.layerContent.tmpAnalysis = item.analysis;
      }
      this.layerContent.layerDialog = true;
    },
    async layerSubmit(){
      const nowObj = this.layerContent.subIndex > -1 ? this.layerContent.currentItem.subQuestions[this.layerContent.subIndex] : this.layerContent.currentItem;
      if(this.layerContent.currentStepId==2){//题干
        nowObj.title=this.layerContent.tmpTitle;
      }
      if(this.layerContent.currentStepId==3){//选项
        if(this.layerContent.tmpOptionsType==1){
          nowObj.options=JSON.stringify(this.layerContent.tmpOptionsSelect);
        }
      }
      if(this.layerContent.currentStepId==4){//答案
        if(this.layerContent.tmpAnswerType==1){
          let rightAnswer = this.layerContent.tmpAnswerSelect.map((option, index) => {
            if(option){
              return index+1;
            }else{
              return 0;
            }
          })
          nowObj.answer=JSON.stringify(rightAnswer.filter(item => item != 0));
        }else{
          nowObj.answer=this.layerContent.tmpAnswerString;
        }
      }
      if(this.layerContent.currentStepId==5){//解析
        nowObj.analysis=this.layerContent.tmpAnalysis;
      }
      this.layerContent.layerDialog = false;
    },
    changeJudgeFlag(){
      this.layerContent.judgeFlag = false;
    },
    formatItemDialogOptions(item,subIndex){
      this.layerContent.tmpOptionsType = 2;
      this.layerContent.tmpOptionsSelect = [];
      this.layerContent.tmpOptionsString = '';
      if(!item.subQuestions[subIndex].options) return '当前没有可编辑的试题选项！';
      if(this.judgeIsArray(item.subQuestions[subIndex].options) && this.judgeIsArray(item.subQuestions[subIndex].answer)){
        //单选或者多选
        const tmpOptionMap = JSON.parse(item.subQuestions[subIndex].options);
        this.layerContent.tmpOptionsType = 1;
        this.layerContent.tmpOptionsSelect = tmpOptionMap;
      }else{
        this.layerContent.tmpOptionsType = 2;
        this.layerContent.tmpOptionsString = item.subQuestions[subIndex].options;
      }
    },
    formatItemDialogAnswer(item,subIndex){
      this.layerContent.tmpAnswerType = 3;
      this.layerContent.tmpAnswerSelect = [];
      this.layerContent.tmpAnswerString = '';
      this.layerContent.judgeFlag = false;
      if(!item.subQuestions[subIndex].answer) return '';
      if(this.judgeIsArray(item.subQuestions[subIndex].options) && this.judgeIsArray(item.subQuestions[subIndex].answer)){
        //单选或者多选
        const tmpAnswer = JSON.parse(item.subQuestions[subIndex].answer);
        this.layerContent.tmpAnswerType = 1;
        let tmpAnswerMap = [];
        this.layerContent.tmpOptionsSelect.map((option, index) => {
          if(tmpAnswer.includes(index+1)){
            tmpAnswerMap.push(true);
          }else{
            tmpAnswerMap.push(false);
          }
        })
        this.layerContent.tmpAnswerSelect = tmpAnswerMap;
      }else{
        if(item.subQuestions[subIndex].answer.replace(/<[^>]*>/g, '') == '正确' || item.subQuestions[subIndex].answer.replace(/<[^>]*>/g, '') == '错误'){
          this.layerContent.tmpAnswerType = 2;
          this.layerContent.judgeFlag = true;
          this.layerContent.tmpAnswerString = item.subQuestions[subIndex].answer.replace(/<[^>]*>/g, '');
        }else{
          this.layerContent.tmpAnswerType = 3;
          this.layerContent.tmpAnswerString = item.subQuestions[subIndex].answer;
        }
      }
    },
    showItemLayer(item,subIndex,stepId){
      this.layerContent.currentItem = item;
      this.layerContent.currentStepId = stepId;
      this.layerContent.subIndex = subIndex;
      this.layerContent.title = this.currentSubItemTitle[stepId];
      if(stepId==2){
        this.layerContent.tmpTitle = item.subQuestions[subIndex].title;
      }
      if(stepId==3){
        this.formatItemDialogOptions(item,subIndex);
      }
      if(stepId==4){
        this.formatItemDialogOptions(item,subIndex);
        this.formatItemDialogAnswer(item,subIndex);
      }
      if(stepId==5){
        this.layerContent.tmpAnalysis = item.subQuestions[subIndex].analysis;
      }
      this.layerContent.layerDialog = true;
    },
  }
}
</script>

<style lang="less" scoped>

.el-dialog__wrapper {
  z-index: 10!important;
}

.standardFormat /deep/ .el-form-item__content {
  display: flex;
}
.mainCon {
    display: flex;
    .titleCourse{
        font-size: 16px;
        font-weight: bold;
    }
    .topDivLeft {
        width: 70%;
        border-radius: 7px;
        li{
          line-height: 45px;
        }
        .topDivLeftTitle{
          font-size: 20px;
          font-weight: bold;
          padding: 5px;
        }
        .leftContent{
          line-height: 35px;
          padding-left: 28px;
          background-color: #F5F7FA;
        }
        .complexLeftContent{
          line-height: 35px;
          padding-left: 28px;
          background-color: #F5F7FA;
        }
        .sub-button{
          margin: 10px 80px 0px;
          .RemindSaveCss{
            margin-left:20px;
            color:red;
            font-weight: bold;
          }
        }
        /deep/ .el-input__inner {
          height: 28px;
          line-height: 28px;
        }
        .titleBlue{
          color:blue;
          font-weight: bold;
          font-size: 20px;
        }
        .titleGreen{
          color:green;
          font-weight: bold;
          font-size: 20px;
        }
    }
    .topDivRight{
        position: sticky;
        top: 20px;
        align-self: flex-start;
        width: 29%;
        margin-left: 1%;
        border-radius: 7px;
        li{
          line-height: 38px;
          font-size: 15px;
        }
        .li-Title{
          font-size: 18px;
          font-weight: bold;
        }
        .li-paddingLeft{
          padding-left:20px;
          height: 30px;
          line-height: 30px;
        }
        .li-green{
          width: 93px;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          color: #009966;
        }
        .li-red{
          width: 93px;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          color: #FF0000;
        }
        .li-button{
          width: 100px;
          text-align: center;
          line-height: 50px;
          margin-top: 10px;
        }
    }
    li {
      line-height: 28px;
    }
    .waiteDiv{
      font-size: 50px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      height:100px;
      line-height: 100px;
      color: #b5bac0;
    }
}
.floating-box {
    position: fixed;
    right: 50px;
    bottom: 65px;
    text-align: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 5;
    /deep/ .el-input {
      width:50px;
      margin-right: 1px;
    }
    /deep/ .el-input__inner {
      width: 50px;
      padding:0px 2px !important;
      text-align: center;
    }
}
.tipRed {
  color: red;
  font-weight: bold;
}
.editPenIcon {
  display: inline-block;
  width: 19px;
  height: 19px;
  background-image: url("../../../assets/img/edit.png");
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-left: 8px;
  vertical-align: middle;
}
.editPenIcon:hover {
  opacity: 0.8;
}
.icon-pointer:hover {
  cursor: pointer;
  opacity: 0.7;
}
.contentCss{
  display: flex;
  justify-content: center;
}
.footerCss{
  margin-top: 20px;
  text-align: center;
}
.maskDiv{
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 6;
  background: #000;
  opacity: 0.6;
  top: 0;
  left: 0;
}
/deep/ .edui-editor{
  margin:0 auto;
}
.topTip{
  color: #006AFF;
  font-size: 15px;
}
.optionSelectFatherCss{
  margin:10px 0px;
}
.optionSelectCss{
  display: inline;
  /deep/ .el-input__inner{
    width:450px !important;
  }
}
/deep/ .answerSelectCss{
  width:450px !important;
}
.answerJudgeFatherCss{
  text-align: center;
  .judgeDiv{
    margin: 0px 0px 20px 0px;
    text-align: left;
    color: #006AFF;
    font-size: 15px;
  }
  .judgeTip{
    margin: 20px 0px 10px 0px;
    color:#E6A23C;
  }
}
</style>